import React from "react";
import { Checkbox, TextField } from "@mui/material";

const DAYS = [
  { key: "mon", label: "Monday" },
  { key: "tue", label: "Tuesday" },
  { key: "wed", label: "Wednesday" },
  { key: "thu", label: "Thursday" },
  { key: "fri", label: "Friday" },
  { key: "sat", label: "Saturday" },
  { key: "sun", label: "Sunday" },
];

const OperatingHours = ({ value, onChange }) => {
  const handleDayToggle = (day) => {
    onChange({
      ...value,
      [day]: value[day] ? null : { open: "08:00", close: "17:00" },
    });
  };

  const handleTimeChange = (day, field, time) => {
    onChange({
      ...value,
      [day]: { ...value[day], [field]: time },
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {DAYS.map(({ key, label }) => (
        <div key={key} style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ display: "flex", alignItems: "center", width: 130, flexShrink: 0 }}>
            <Checkbox
              checked={Boolean(value[key])}
              onChange={() => handleDayToggle(key)}
              color="primary"
              size="small"
              sx={{ p: "4px" }}
            />
            <span style={{ fontSize: "0.875rem" }}>{label}</span>
          </div>
          <TextField
            label="Open"
            type="time"
            size="small"
            disabled={!value[key]}
            value={value[key]?.open || ""}
            onChange={(e) => handleTimeChange(key, "open", e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ step: 300 }}
            sx={{ flex: 1 }}
          />
          <TextField
            label="Close"
            type="time"
            size="small"
            disabled={!value[key]}
            value={value[key]?.close || ""}
            onChange={(e) => handleTimeChange(key, "close", e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ step: 300 }}
            sx={{ flex: 1 }}
          />
        </div>
      ))}
    </div>
  );
};

export default OperatingHours;
